import { Controller } from "@hotwired/stimulus"
import autocomplete from 'autocompleter';
import { Turbo } from "@hotwired/turbo-rails"

// Connects to data-controller="cars"
export default class extends Controller {
  static values = { id: Array }
  connect() {
    console.log("connected to messages controller")
    console.log("this.idValue", this.idValue)
    document.getElementById('message_body').value = ""
    // scrol to message
    var objDiv = document.getElementById("messages");
    objDiv.scrollTop = objDiv.scrollHeight;

    var input = document.getElementById("message_search");

    if (input) {
      let ids = this.idValue
      autocomplete({
        onSelect: function (item, input) {
          let url = `/bookings/${item.vseprokaty_id}/messages`
          console.log("replaceToBookingMessages",)
          Turbo.visit(url, { action: "replace" });
        },
        input: input,
        showOnFocus: false,
        minLength: 2,
        emptyMsg: 'Не найдено',
        render: function (item, currentValue) {
          var li = document.createElement("li");
          li.classList.add("text-gray-700", "block", "px-4", "py-2", "text-base", "text-left", "hover:border-b", "cursor-pointer")
          const fmt = item._formatted || {};
          li.innerHTML = `${fmt.car_name || item.car_name} <br /> ${fmt.start_date || item.start_date} - ${fmt.end_date || item.end_date}`;
          return li;
        },
        className: 'origin-bottom absolute w-full rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none',
        fetch: function (text, update) {
          const params = new URLSearchParams();
          params.append('q', text);
          (ids || []).forEach((id) => params.append('ids[]', id));

          fetch(`/search/bookings?${params.toString()}`, {
            headers: { 'Accept': 'application/json' },
            credentials: 'same-origin'
          })
            .then((response) => response.json())
            .then((data) => {
              update(data.hits || []);
              console.log(data.hits);
            })
            .catch((error) => {
              console.log(error);
            });
        },
        debounceWaitMs: 100,
        preventSubmit: true,
        disableAutoSelect: false,
        container: document.createElement("ul"),
      });
    }
  }
  clearForm() {
    document.getElementById('message_body').value = ""
    // scrol to message
    var objDiv = document.getElementById("messages");
    console.log("objDiv", objDiv)
    objDiv.scrollTop = objDiv.scrollHeight;
  }
}
